// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"styles_containerMain__4ZzfK","wrapper":"styles_wrapper__237sa","title":"styles_title__IGxRB","text":"styles_text__3SBXb","column":"styles_column__i0cPt"};